const CLIP = 'polygon(50% 0, 100% 25%, 100% 75%, 50% 100%, 0 75%, 0 25%)';

/**
 * Hexágono doble: el exterior de color hace de borde, el interior blanco
 * lleva el icono. Tamaños en uso: 44-46 (KPIs), 50-56 (franjas), 64 (rango
 * actual), 84-96 (camino de rangos).
 */
export const Hexagon = ({
  size = 50,
  color = '#4B36F0',
  icon,
  filled = false,
  halo = false,
  children,
}) => (
  <div
    className="ui-hex"
    style={{
      width: size,
      height: size * 1.1,
      background: color,
      clipPath: CLIP,
      boxShadow: halo ? `0 0 0 6px ${color}24` : undefined,
    }}
  >
    <div
      className="ui-hex__inner"
      style={{
        width: size - 4,
        height: size * 1.1 - 4,
        background: filled ? color : '#fff',
        clipPath: CLIP,
      }}
    >
      {icon && (
        <i className={icon} style={{ color: filled ? '#fff' : color, fontSize: size * 0.38 }} />
      )}
      {children}
    </div>
  </div>
);

export default Hexagon;
